var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12",attrs:{"id":"Formato7"}},_vm._l((_vm.contenidos),function(contenido,index){return _c('embed',{key:index,class:_vm.columnasContenido(contenido.TamanoDeLaColumna),attrs:{"src":contenido.RutaDeArchivo}})}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ed9b2e2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Micrositios/Formatos/ContenidoEmbebido.vue
// module id = null
// module chunks = 